import { ContentType } from '@/utils/curation'

import {
  collectionFilter,
  collectionSearch,
  collectionSort,
  collectionSuggestions,
  creatorFilter,
  creatorSearch,
  creatorSort,
  creatorSuggestions,
  itemFilter,
  itemSearch,
  itemSort,
  itemSuggestions,
} from './explore.schema'
import {
  ownedItemFilter,
  ownedItemSearch,
  ownedItemSort,
  ownedItemSuggestions,
} from './tokens.schema'

// Search function
export const searchFunction = (contentType: ContentType, searchString: string) => {
  if (searchString === '') {
    return {} // No search filter by default
  }
  switch (contentType) {
    case 'creators':
      return creatorSearch(searchString)
    case 'collections':
      return collectionSearch(searchString)
    case 'collection_items':
      return itemSearch(searchString)
    case 'items':
      return itemSearch(searchString)
    case 'user_published':
      return itemSearch(searchString)
    case 'user_owned':
      return ownedItemSearch(searchString)
    case 'user_earned':
      return ownedItemSearch(searchString)
    default:
      return {}
  }
}

// Filter function
export const filterFunction = (contentType: ContentType, filteredBy: string) => {
  switch (contentType) {
    case 'creators':
      return creatorFilter(filteredBy)
    case 'collections':
      return collectionFilter(filteredBy)
    case 'collection_items':
      return itemFilter(filteredBy)
    case 'items':
      return itemFilter(filteredBy)
    case 'user_published':
      return itemFilter(filteredBy)
    case 'user_owned':
      return ownedItemFilter(filteredBy)
    case 'user_earned':
      return ownedItemFilter(filteredBy)
    default:
      return {}
  }
}

// Sort function
export const sortFunction = (
  contentType: ContentType,
  sortedBy: string,
  direction: 'asc' | 'desc'
) => {
  switch (contentType) {
    case 'creators':
      return creatorSort(sortedBy, direction)
    case 'collections':
      return collectionSort(sortedBy, direction)
    case 'collection_items':
      return itemSort(sortedBy, direction)
    case 'items':
      return itemSort(sortedBy, direction)
    case 'user_published':
      return itemSort(sortedBy, direction)
    case 'user_owned':
      return ownedItemSort(sortedBy, direction)
    case 'user_earned':
      return ownedItemSort(sortedBy, direction)
    default:
      return {}
  }
}

// Suggestion function
export const suggestionFunction = (contentType: ContentType, searchString: string) => {
  if (searchString === '') {
    return {} // No search filter by default
  }
  switch (contentType) {
    case 'creators':
      return creatorSuggestions(searchString)
    case 'collections':
      return collectionSuggestions(searchString)
    case 'collection_items':
      return itemSuggestions(searchString)
    case 'items':
      return itemSuggestions(searchString)
    case 'user_published':
      return itemSuggestions(searchString)
    case 'user_owned':
      return ownedItemSuggestions(searchString)
    case 'user_earned':
      return ownedItemSuggestions(searchString)
    default:
      return {}
  }
}
